import { BrowserRouter } from "react-router-dom";

type Props = { children: JSX.Element };
export const ReactRouterWrapper = ({ children }: Props) => (
  <BrowserRouter>{children}</BrowserRouter>
);
